import script from "./UserSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSearch.vue?vue&type=script&setup=true&lang=js"

import "./UserSearch.vue?vue&type=style&index=0&id=0e69a254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e69a254"]])

export default __exports__